import { useUIStore } from '@/config/stores/ui-store';
import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect } from 'react';

export const useLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { sidebarExpanded, toggleSidebar, toggleAside, asideExpanded } = useUIStore();

  // Auto close drawer on mobile when screen size changes
  useEffect(() => {
    if (isMobile && sidebarExpanded && toggleSidebar) {
      toggleSidebar();
    }

    if (isMobile && asideExpanded && toggleAside) {
      toggleAside();
    }
  }, [isMobile]);

  return {
    sidebarExpanded,
    isMobile,
    toggleSidebar,
    toggleAside,
    asideExpanded
  };
};
